window.MOBILE = Modernizr.mq('(max-width: 767px)')
window.DESKTOP = Modernizr.mq('(min-width: 768px)')
